module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_10_m.017414f164319f19cde2738060f14122.png";